import * as Dialog from '@radix-ui/react-dialog';
import { styled } from 'styled-components';
import { Navbar } from '../Navbar';
import { Typography, radius, space, tk, tok, tokPx } from '@sunwebgroup/ui-components';
import { MenuTrigger } from '../Menu/Trigger';
import { HeaderLink } from '../HeaderLink';

/**
 * This is the Sheet component used for the mobile version of the navigation menu.
 */

const Content = styled(Dialog.Content)`
  background: ${tok('semantics_backgrounds_background_color')};
  height: calc(100vh - 100%); // 100% is the height of the header
  padding: ${space('primitives_space_16')} 0;
  position: absolute;
  right: 0;
  top: 100%;
  width: 100vw;
  border-top: 1px solid ${tok('semantics_dividers_color')};
  z-index: 1;

  @media (min-width: ${tokPx('primitives_breakpoint_m_min')}) {
    max-width: 375px;
  }

  @media (min-width: ${tokPx('primitives_breakpoint_m_max')}) {
    display: none;
  }

  ${Navbar} {
    position: relative;
    height: 100%;

    & > div,
    ${Navbar.List} {
      height: 100%;
    }
    & > ${Typography}:first-child {
      display: block;
      padding: ${space('primitives_space_12')} ${space('primitives_space_24')};
    }
  }

  ${Navbar.List} {
    display: block;
    position: relative;
    overflow: auto;

    & > ${Typography} {
      display: block;
      margin-bottom: ${space('primitives_space_12')};
      padding: 0 ${space('primitives_space_24')};
    }

    & ${Navbar.Item} {
      & ${MenuTrigger} {
        padding: ${space('primitives_space_12')} ${space('primitives_space_24')};
        width: 100%;
        &:hover {
          color: inherit;
          background: ${tok('primitives_color_neutral_100')};
        }
      }
    }

    ${HeaderLink} {
      padding: ${space('primitives_space_12')} ${space('primitives_space_24')};
      width: 100%;
      &:hover {
        color: ${tok('semantics_links_hover_color')};
      }
    }

    ${Navbar.Content} {
      background: ${tok('semantics_backgrounds_background_color')};
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;

      & > ${Typography}, & > button {
        display: flex;
        margin-bottom: ${space('primitives_space_12')};
        padding: 0 ${space('primitives_space_24')};
      }
    }
  }

  ${MenuTrigger} {
    border-radius: ${radius('primitives_corner_radius_none')};
  }
`;

const Overlay = styled(Dialog.Overlay)`
  background: ${tok('components_backdrop_color')}; //To replace with the new token
  height: calc(100vh - 100%);
  left: 0;
  position: absolute;
  top: 100%;
  width: 100vw;
  z-index: -1;

  @media (min-width: ${tokPx('primitives_breakpoint_m_max')}) {
    display: none;
  }
`;

const Trigger = styled(Dialog.Trigger)`
  padding: ${space('primitives_space_8')} ${space('primitives_space_16')};
  @media (min-width: ${tokPx('primitives_breakpoint_m_max')}) {
    display: none;
  }
`;

export const Sheet = {
  Content,
  Overlay,
  Trigger,
  Root: styled(Dialog.Root)``,
  Close: styled(Dialog.Close)``,
  Portal: styled(Dialog.Portal)``,
};
